import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import ExpiryForm from './ExpiryForm';
import DocumentsUpload from './DocumentsUpload';
import ActeAuto from './ActeAuto';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444';
const s = {
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'14px',padding:'18px 22px',marginBottom:'12px'},
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};


function QRSection({ vehicle }) {
  const [copied, setCopied] = React.useState(false);
  if (!vehicle.vehicle_token) return null;
  const publicUrl = 'https://dosarmasina.ro/masina/' + vehicle.vehicle_token;

  const copyLink = () => {
    navigator.clipboard.writeText(publicUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const downloadQR = () => {
    const canvas = document.querySelector('#qr-canvas-' + vehicle.id + ' canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = 'qr-' + (vehicle.plate_number || vehicle.id) + '.png';
    a.click();
  };

  const btnBase = { padding: '9px 16px', borderRadius: '10px', fontSize: '12px', fontWeight: 700, cursor: 'pointer', border: 'none', fontFamily: "'Syne',sans-serif" };

  return (
    <div style={{ background: '#fff', border: '0.5px solid #D3D1C7', borderRadius: '14px', padding: '18px 22px', marginBottom: '16px' }}>
      <div style={{ fontSize: '14px', fontWeight: 800, marginBottom: '14px', color: DARK }}>🔗 QR Code Masina</div>
      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div id={'qr-canvas-' + vehicle.id} style={{ background: '#fff', padding: '10px', borderRadius: '10px', border: '0.5px solid #D3D1C7', display: 'inline-block' }}>
          <QRCodeCanvas value={publicUrl} size={128} bgColor='#ffffff' fgColor={DARK} level='M'/>
        </div>
        <div style={{ flex: 1, minWidth: '200px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: '6px' }}>Link public</div>
          <div style={{ background: '#F4F4F4', border: '0.5px solid #D3D1C7', borderRadius: '9px', padding: '9px 13px', fontSize: '12px', fontFamily: 'monospace', color: DARK, marginBottom: '12px', wordBreak: 'break-all' }}>
            {publicUrl}
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button onClick={copyLink} style={{ ...btnBase, background: copied ? '#DCFCE7' : '#F4F4F4', color: copied ? '#15803D' : DARK, border: '0.5px solid #D3D1C7' }}>
              {copied ? '✓ Copiat!' : '📋 Copiaza link'}
            </button>
            <button onClick={downloadQR} style={{ ...btnBase, background: GOLD, color: DARK }}>
              ⬇ Descarca QR
            </button>
          </div>
          <div style={{ fontSize: '11px', color: '#888', marginTop: '10px' }}>
            Acces public fara autentificare · afiseaza expirari si documente
          </div>
        </div>
      </div>
    </div>
  );
}

function ExpiryTab({ vehicle, refreshKey = 0 }) {
  const [expirari, setExpirari] = useState({
    rca_expiry:'', casco_expiry:'', itp_expiry:'', rovinieta_expiry:'', current_km:'', revizie_km:''
  });
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [customExpirari, setCustomExpirari] = useState([]);

  const deleteCustomExpiry = async (id) => {
    await api(`/expiry/custom/${id}`, { method: "DELETE" });
    setCustomExpirari(prev => prev.filter(c => c.id !== id));
  };

  useEffect(() => {
    api(`/expiry/${vehicle.id}`).then(d => {
      if (d.vehicle) {
        setExpirari({
          rca_expiry: d.vehicle.rca_expiry ? d.vehicle.rca_expiry.split('T')[0] : '',
          casco_expiry: d.vehicle.casco_expiry ? d.vehicle.casco_expiry.split('T')[0] : '',
          itp_expiry: d.vehicle.itp_expiry ? d.vehicle.itp_expiry.split('T')[0] : '',
          rovinieta_expiry: d.vehicle.rovinieta_expiry ? d.vehicle.rovinieta_expiry.split('T')[0] : '',
          current_km: d.vehicle.current_km || '',
          revizie_km: d.vehicle.revizie_km || '',
        });
      }
    });
    api(`/expiry/custom/${vehicle.id}`).then(d => {
      if (d.expiries) setCustomExpirari(d.expiries);
    });
  }, [vehicle.id, refreshKey]);

  const daysLeft = (dateStr) => {
    if (!dateStr) return null;
    return Math.ceil((new Date(dateStr) - new Date()) / (1000*60*60*24));
  };

  const statusColor = (days) => {
    if (days === null) return '#D3D1C7';
    if (days < 0) return RED;
    if (days <= 7) return RED;
    if (days <= 30) return GOLD;
    return GREEN;
  };

  const statusBg = (days) => {
    if (days === null) return '#F4F4F4';
    if (days < 0) return '#FEE2E2';
    if (days <= 7) return '#FEE2E2';
    if (days <= 30) return '#FEF3DC';
    return '#DCFCE7';
  };

  const save = async () => {
    setLoading(true);
    const data = await api(`/expiry/${vehicle.id}`, { method:'PUT', body: JSON.stringify(expirari) });
    setMsg(data.message ? '✓ ' + data.message : (data.error || 'Eroare'));
    setLoading(false);
    setTimeout(() => setMsg(''), 3000);
  };

  const docs = [
    { label:'RCA', key:'rca_expiry', icon:'🛡️', verifyUrl:'https://www.aida.info.ro/polite-rca' },
    { label:'CASCO', key:'casco_expiry', icon:'🚗', verifyUrl:null },
    { label:'ITP', key:'itp_expiry', icon:'🔍', verifyUrl:'https://prog.rarom.ro/rarpol/rarpol.asp?' },
    { label:'Rovinieta', key:'rovinieta_expiry', icon:'🛣️', verifyUrl:'https://www.cnadnr.ro/ro/verificare-rovinieta' },
  ];

  return (
    <div>
      {/* Carduri expirări */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:'10px',marginBottom:'16px'}}>
        {docs.map(d => {
          const days = daysLeft(expirari[d.key]);
          const color = statusColor(days);
          const bg = statusBg(days);
          return (
            <div key={d.key} style={{background:'#fff',border:`0.5px solid #D3D1C7`,borderRadius:'12px',padding:'14px',borderTop:`3px solid ${color}`}}>
              <div style={{fontSize:'11px',fontWeight:700,color:'#888',textTransform:'uppercase',marginBottom:'6px'}}>{d.icon} {d.label}</div>
              {expirari[d.key] ? (
                <>
                  <div style={{fontFamily:'monospace',fontSize:'14px',fontWeight:700,marginBottom:'6px'}}>
                    {new Date(expirari[d.key]).toLocaleDateString('ro-RO')}
                  </div>
                  <span style={{background:bg,color,fontSize:'11px',fontWeight:700,padding:'3px 10px',borderRadius:'7px'}}>
                    {days < 0 ? '✗ Expirat' : days === 0 ? '⚠ Expiră azi' : `${days} zile`}
                  </span>
                </>
              ) : (
                <div style={{fontSize:'12px',color:'#aaa'}}>Nedefinit</div>
              )}
            </div>
          );
        })}
      </div>



      {customExpirari.length > 0 && (
        <div style={{marginBottom:'16px'}}>
          <div style={{fontSize:'11px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'8px'}}>
            Documente personalizate
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:'10px'}}>
            {customExpirari.map(c => {
              const days = daysLeft(c.expiry_date);
              const color = statusColor(days);
              const bg = statusBg(days);
              return (
                <div key={c.id} style={{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'12px',padding:'14px',borderTop:'3px solid '+color,position:'relative'}}>
                  <button onClick={() => deleteCustomExpiry(c.id)}
                    style={{position:'absolute',top:'8px',right:'8px',background:'transparent',border:'none',cursor:'pointer',fontSize:'14px',color:'#aaa',lineHeight:1,padding:0}}>x</button>
                  <div style={{fontSize:'11px',fontWeight:700,color:'#888',textTransform:'uppercase',marginBottom:'6px',paddingRight:'18px'}}>{c.label}</div>
                  {c.expiry_date ? (
                    <>
                      <div style={{fontFamily:'monospace',fontSize:'14px',fontWeight:700,marginBottom:'6px'}}>
                        {new Date(c.expiry_date).toLocaleDateString('ro-RO')}
                      </div>
                      <span style={{background:bg,color,fontSize:'11px',fontWeight:700,padding:'3px 10px',borderRadius:'7px'}}>
                        {days < 0 ? 'Expirat' : days === 0 ? 'Expira azi' : days+' zile'}
                      </span>
                    </>
                  ) : (
                    <div style={{fontSize:'12px',color:'#aaa'}}>Data nedefinita</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* QR Code Masina */}
      <QRSection vehicle={vehicle}/>

      {/* Separator */}
      <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'16px'}}>
        <div style={{flex:1,height:'1px',background:'#E5E5E5'}}/>
        <div style={{fontSize:'15px',fontWeight:800,color:DARK,letterSpacing:'.3px'}}>⚙️ Setează expirările</div>
        <div style={{flex:1,height:'1px',background:'#E5E5E5'}}/>
      </div>

      {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'12px'}}>{msg}</div>}

      <div style={{display:'flex',flexDirection:'column',gap:'12px',marginBottom:'12px'}}>
        {docs.map(d => (
          <div key={d.key} style={{background:'#fff',borderRadius:'12px',padding:'14px 16px',border:'0.5px solid #E5E5E5'}}>
            <label style={{fontSize:'14px',fontWeight:700,color:DARK,marginBottom:'8px',display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap'}}>
              <span style={{fontSize:'18px'}}>{d.icon}</span>
              <span>{d.label}</span>
              {d.verifyUrl && (
                <a href={d.verifyUrl} target="_blank" rel="noreferrer"
                  style={{fontSize:'11px',color:NAVY,marginLeft:'4px',fontWeight:600,textDecoration:'none'}}>
                  🔍 Verifică online
                </a>
              )}
            </label>
            <input style={{...s.input,fontSize:'14px',padding:'10px 14px'}} type="date" value={expirari[d.key]||''}
              onChange={e=>setExpirari({...expirari,[d.key]:e.target.value})}/>
          </div>
        ))}
      </div>

      <button onClick={save} disabled={loading} style={{...s.btn,background:GOLD,color:DARK,width:'100%'}}>
        {loading ? 'Se salvează...' : '💾 Salvează expirările'}
      </button>
      <div style={{fontSize:'11px',color:'#888',textAlign:'center',marginTop:'8px'}}>
        🔔 Vei primi email cu 30, 7 și 1 zi înainte de expirare
      </div>
    </div>
  );
}


const URGENCY_OPTIONS = [
  {val:'normal', label:'Normal (3-5 zile)'},
  {val:'urgent', label:'Urgent (24h)'},
  {val:'very_urgent', label:'Foarte urgent (acum)'},
];

function ServicesSection({ vehicle }) {
  const [services, setServices] = React.useState([]);
  const [vehicleDocs, setVehicleDocs] = React.useState([]);
  const [modal, setModal] = React.useState(null);
  const [form, setForm] = React.useState({ description: '', location: 'Iași', urgency: 'normal', attachTalon: false });
  const [rcaForm, setRcaForm] = React.useState({
    owner_name: '', owner_cnp: '', owner_address: '', owner_email: '', owner_license_date: '',
    rca_start_date: '',
  });
  const [uploadingDoc, setUploadingDoc] = React.useState(null); // 'talon' | 'buletin' | null
  const [msg, setMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  const tomorrow = () => {
    const d = new Date(); d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
  };

  const loadDocs = React.useCallback(() => {
    const token = localStorage.getItem('token');
    if (vehicle.id) {
      fetch('/api/documents/vehicle/' + vehicle.id, { headers: { Authorization: 'Bearer ' + token } })
        .then(r => r.json()).then(d => { if (d.documents) setVehicleDocs(d.documents); });
    }
  }, [vehicle.id]);

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/marketplace/services', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(d => { if (d.services) setServices(d.services); });
    loadDocs();
  }, [vehicle.id, loadDocs]);

  const isRCA = (svc) => svc && svc.slug === 'rca_casco';

  // Returns the document object for a given type, or null
  const getDoc = (type) => vehicleDocs.find(d => d.doc_type === type) || null;
  const hasDoc = (type) => vehicleDocs.some(d => d.doc_type === type);

  // Get OCR data from a doc's stored fields
  const getOcrOwner = () => {
    const buletin = getDoc('ci_proprietar') || getDoc('buletin') || getDoc('civ');
    if (!buletin) return {};
    const data = buletin.ocr_extracted_data || buletin.ocr_data || {};
    return data;
  };

  const openModal = (svc) => {
    setModal(svc);
    setMsg('');
    setSubmitted(false);
    setForm({ description: '', location: 'Iași', urgency: 'normal', attachTalon: hasDoc('talon') });

    if (isRCA(svc)) {
      const ocrOwner = getOcrOwner();
      setRcaForm({
        owner_name: ocrOwner.first_name && ocrOwner.last_name
          ? `${ocrOwner.first_name} ${ocrOwner.last_name}`
          : (ocrOwner.owner_name || ''),
        owner_cnp: ocrOwner.cnp || '',
        owner_address: ocrOwner.address || '',
        owner_email: '',
        owner_license_date: '',
        rca_start_date: tomorrow(),
      });
    }
  };

  const closeModal = () => { setModal(null); setMsg(''); setSubmitted(false); setUploadingDoc(null); };

  // Inline doc upload inside RCA modal
  const uploadDocInModal = async (file, docType) => {
    if (!file || !vehicle.id) return;
    setUploadingDoc(docType);
    try {
      const token = localStorage.getItem('token');
      const fd = new FormData();
      fd.append('file', file);
      fd.append('vehicle_id', vehicle.id);
      fd.append('doc_type', docType);
      const res = await fetch('/api/documents/upload', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: fd,
      });
      const d = await res.json();
      if (d.document) {
        loadDocs();
        setMsg('✓ Document adăugat în dosar.');
      } else {
        setMsg(d.error || 'Eroare upload document.');
      }
    } catch { setMsg('Eroare conexiune.'); }
    setUploadingDoc(null);
    setTimeout(() => setMsg(''), 3000);
  };

  const submit = async () => {
    if (!isRCA(modal) && !form.description.trim()) { setMsg('Adaugă o descriere a solicitării.'); return; }
    if (isRCA(modal) && !rcaForm.owner_name.trim()) { setMsg('Numele proprietarului este obligatoriu.'); return; }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const attachTypes = [];
      if (isRCA(modal)) {
        if (hasDoc('talon')) attachTypes.push('talon');
        if (hasDoc('buletin')) attachTypes.push('buletin');
        if (hasDoc('ci_proprietar')) attachTypes.push('ci_proprietar');
        if (hasDoc('civ')) attachTypes.push('civ');
      } else if (form.attachTalon && hasDoc('talon')) {
        attachTypes.push('talon');
      }

      const missingDocs = [];
      if (isRCA(modal)) {
        if (!hasDoc('talon')) missingDocs.push('talon');
        if (!hasDoc('buletin') && !hasDoc('ci_proprietar') && !hasDoc('civ')) missingDocs.push('buletin proprietar');
      }

      const payload = {
        vehicle_id: vehicle.id,
        service_slug: modal.slug,
        description: isRCA(modal)
          ? `Solicitare RCA — ${vehicle.plate_number || vehicle.vin || 'vehicul'} — start: ${rcaForm.rca_start_date}${missingDocs.length ? ' — LIPSĂ: ' + missingDocs.join(', ') : ''}`
          : form.description,
        urgency: form.urgency,
        location: form.location,
        attach_doc_types: attachTypes,
        missing_docs: missingDocs,
        ...(isRCA(modal) ? {
          ...rcaForm,
          itp_expiry: vehicle.itp_expiry ? vehicle.itp_expiry.split('T')[0] : '',
        } : {}),
      };

      const res = await fetch('/api/marketplace/request-service', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.request) {
        setSubmitted(true);
      } else {
        setMsg(data.error || 'Eroare la trimitere.');
      }
    } catch { setMsg('Eroare conexiune server.'); }
    setLoading(false);
  };

  if (services.length === 0) return null;

  const inp = { background: '#F4F4F4', border: '0.5px solid #D3D1C7', borderRadius: '9px', padding: '9px 13px', fontSize: '13px', width: '100%', fontFamily: "'Syne',sans-serif", outline: 'none', boxSizing: 'border-box' };
  const lbl = { fontSize: '10px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: '4px', display: 'block' };

  // Doc status badge with optional upload button
  const DocBadge = ({ docTypes, label, icon }) => {
    const found = docTypes.some(t => hasDoc(t));
    const uploadType = docTypes[0];
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: found ? '#F0FFF4' : '#FEF2F2', borderRadius: '8px', border: `0.5px solid ${found ? '#86EFAC' : '#FECACA'}` }}>
        <span style={{ fontSize: '12px', fontWeight: 700, color: found ? '#15803D' : RED }}>
          {icon} {label}: {found ? '✓ disponibil' : '✗ lipsă'}
        </span>
        {!found && (
          <label style={{ cursor: 'pointer' }}>
            <input type="file" accept=".jpg,.jpeg,.png,.pdf" style={{ display: 'none' }}
              onChange={e => { if (e.target.files[0]) uploadDocInModal(e.target.files[0], uploadType); }} />
            <span style={{ background: NAVY, color: '#fff', fontSize: '10px', fontWeight: 700, padding: '4px 10px', borderRadius: '6px', display: 'inline-block', cursor: 'pointer' }}>
              {uploadingDoc === uploadType ? '⏳...' : '📎 Încarcă'}
            </span>
          </label>
        )}
      </div>
    );
  };

  return (
    <div style={{ marginTop: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
        <div style={{ flex: 1, height: '1px', background: '#E5E5E5' }} />
        <div style={{ fontSize: '13px', fontWeight: 800, color: DARK }}>🔧 Servicii disponibile</div>
        <div style={{ flex: 1, height: '1px', background: '#E5E5E5' }} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px' }}>
        {services.map(svc => (
          <div key={svc.id} style={{ background: '#fff', border: '0.5px solid #D3D1C7', borderRadius: '12px', padding: '14px', display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '9px', background: svc.color || '#F4F4F4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>{svc.icon}</div>
              <div>
                <div style={{ fontWeight: 700, fontSize: '13px', color: DARK }}>{svc.name}</div>
                {svc.description && <div style={{ fontSize: '10px', color: '#888', marginTop: '2px', lineHeight: 1.3 }}>{svc.description}</div>}
              </div>
            </div>
            <button onClick={() => openModal(svc)}
              style={{ background: GOLD, color: DARK, border: 'none', borderRadius: '8px', padding: '7px 14px', fontSize: '12px', fontWeight: 700, cursor: 'pointer', flexShrink: 0, fontFamily: "'Syne',sans-serif", whiteSpace: 'nowrap' }}>
              Solicită
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modal && (
        <div onClick={closeModal} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '14px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto' }}>
            {/* Header */}
            <div style={{ background: NAVY, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 1 }}>
              <div>
                <div style={{ color: '#fff', fontWeight: 800, fontSize: '15px' }}>{modal.icon} {modal.name}</div>
                <div style={{ color: 'rgba(255,255,255,.6)', fontSize: '11px', marginTop: '2px' }}>
                  {vehicle.plate_number && <span style={{ fontFamily: 'monospace', fontWeight: 700, color: GOLD }}>{vehicle.plate_number}</span>}
                  {vehicle.brand && <span> · {vehicle.brand} {vehicle.model}</span>}
                </div>
              </div>
              <button onClick={closeModal} style={{ background: 'rgba(255,255,255,.15)', border: 'none', borderRadius: '8px', padding: '6px 10px', color: '#fff', cursor: 'pointer', fontSize: '15px' }}>✕</button>
            </div>

            {submitted ? (
              <div style={{ padding: '40px 24px', textAlign: 'center' }}>
                <div style={{ fontSize: '52px', marginBottom: '12px' }}>✅</div>
                <div style={{ fontWeight: 800, fontSize: '18px', marginBottom: '8px', color: DARK }}>Solicitare trimisă!</div>
                <div style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>
                  {isRCA(modal) ? 'Un broker partener îți va trimite oferte de preț în curând.' : 'Colaboratorii vor răspunde cu oferte în curând.'}
                </div>
                <button onClick={closeModal} style={{ background: GOLD, color: DARK, border: 'none', borderRadius: '10px', padding: '11px 28px', fontWeight: 700, fontSize: '13px', cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}>
                  Închide
                </button>
              </div>
            ) : (
              <div style={{ padding: '20px' }}>
                {isRCA(modal) ? (
                  <>
                    {/* ── 1. Documente în dosar ── */}
                    <div style={{ fontWeight: 700, fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: '8px' }}>📁 Documente în dosar</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' }}>
                      <DocBadge docTypes={['talon']} label="Talon" icon="📄" />
                      <DocBadge docTypes={['buletin', 'ci_proprietar', 'civ']} label="Buletin / CI proprietar" icon="🪪" />
                    </div>

                    {/* ── 2. Date proprietar ── */}
                    <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY, marginBottom: '10px' }}>👤 Date proprietar</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={lbl}>Nume complet *</label>
                        <input style={inp} value={rcaForm.owner_name} onChange={e => setRcaForm({ ...rcaForm, owner_name: e.target.value })} placeholder="Popescu Ion" />
                      </div>
                      <div>
                        <label style={lbl}>CNP</label>
                        <input style={inp} value={rcaForm.owner_cnp} onChange={e => setRcaForm({ ...rcaForm, owner_cnp: e.target.value })} placeholder="1900101..." />
                      </div>
                      <div>
                        <label style={lbl}>Data obținerii permisului</label>
                        <input style={inp} type="date" value={rcaForm.owner_license_date} onChange={e => setRcaForm({ ...rcaForm, owner_license_date: e.target.value })} />
                      </div>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={lbl}>Adresă</label>
                        <input style={inp} value={rcaForm.owner_address} onChange={e => setRcaForm({ ...rcaForm, owner_address: e.target.value })} placeholder="Str. Exemplu 1, Iași" />
                      </div>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={lbl}>Email proprietar</label>
                        <input style={inp} value={rcaForm.owner_email} onChange={e => setRcaForm({ ...rcaForm, owner_email: e.target.value })} placeholder="email@exemplu.ro" />
                      </div>
                    </div>

                    {/* ── 3. Date vehicul ── */}
                    <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY, marginBottom: '8px' }}>🚗 Date vehicul</div>
                    <div style={{ background: '#F4F4F4', borderRadius: '10px', padding: '12px', marginBottom: '14px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                      {[
                        ['Nr. înmatriculare', vehicle.plate_number],
                        ['Marcă', vehicle.brand],
                        ['Model', vehicle.model],
                        ['An fabricație', vehicle.year],
                        ['Combustibil', vehicle.fuel_type],
                        ['Cilindree', vehicle.engine_cc ? vehicle.engine_cc + ' cc' : null],
                        ['Putere', vehicle.power_kw ? vehicle.power_kw + ' kW' : null],
                        ['Norma euro', vehicle.emission_norm],
                        ['Serie șasiu (VIN)', vehicle.vin],
                      ].filter(([, v]) => v).map(([k, v]) => (
                        <div key={k}>
                          <div style={{ fontSize: '9px', color: '#888', fontWeight: 700, textTransform: 'uppercase' }}>{k}</div>
                          <div style={{ fontSize: '13px', fontWeight: 600, fontFamily: k === 'Nr. înmatriculare' || k === 'Serie șasiu (VIN)' ? 'monospace' : 'inherit', color: k === 'Nr. înmatriculare' ? GOLD : DARK }}>{v}</div>
                        </div>
                      ))}
                    </div>

                    {/* ── 4. Dată intrare vigoare RCA + ITP ── */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '16px' }}>
                      <div>
                        <label style={{ ...lbl, color: NAVY }}>Când intră în vigoare RCA? *</label>
                        <input style={{ ...inp, borderColor: NAVY }} type="date" value={rcaForm.rca_start_date} onChange={e => setRcaForm({ ...rcaForm, rca_start_date: e.target.value })} />
                      </div>
                      <div>
                        <label style={lbl}>Expirare ITP</label>
                        <input style={{ ...inp, background: vehicle.itp_expiry ? '#E8F4E8' : '#F4F4F4' }} type="date" readOnly value={vehicle.itp_expiry ? vehicle.itp_expiry.split('T')[0] : ''} />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ marginBottom: '12px' }}>
                      <label style={lbl}>Descriere solicitare *</label>
                      <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                        style={{ ...inp, minHeight: '90px', resize: 'vertical' }}
                        placeholder="Descrie ce ai nevoie..." />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                      <div>
                        <label style={lbl}>Urgență</label>
                        <select value={form.urgency} onChange={e => setForm({ ...form, urgency: e.target.value })} style={inp}>
                          <option value="normal">Normal (3-5 zile)</option>
                          <option value="urgent">Urgent (24h)</option>
                          <option value="very_urgent">Foarte urgent (acum)</option>
                        </select>
                      </div>
                      <div>
                        <label style={lbl}>Locație</label>
                        <input value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} style={inp} placeholder="Iași" />
                      </div>
                    </div>
                    {hasDoc('talon') && (
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#555', marginBottom: '12px', cursor: 'pointer' }}>
                        <input type="checkbox" checked={form.attachTalon} onChange={e => setForm({ ...form, attachTalon: e.target.checked })} style={{ width: '16px', height: '16px' }} />
                        <span>📎 Atașează talonul din dosar la email</span>
                      </label>
                    )}
                  </>
                )}

                {msg && (
                  <div style={{ background: msg.includes('✓') ? '#DCFCE7' : '#FEE2E2', borderRadius: '8px', padding: '9px 12px', fontSize: '12px', color: msg.includes('✓') ? '#15803D' : '#B91C1C', marginBottom: '12px' }}>{msg}</div>
                )}

                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={submit} disabled={loading}
                    style={{ background: GOLD, color: DARK, border: 'none', borderRadius: '10px', padding: '11px 22px', fontWeight: 700, fontSize: '13px', cursor: loading ? 'not-allowed' : 'pointer', flex: 1, fontFamily: "'Syne',sans-serif", opacity: loading ? 0.7 : 1 }}>
                    {loading ? 'Se trimite...' : (isRCA(modal) ? '📤 Trimite solicitarea RCA' : 'Trimite solicitarea →')}
                  </button>
                  <button onClick={closeModal}
                    style={{ background: 'transparent', border: '0.5px solid #D3D1C7', color: '#555', borderRadius: '10px', padding: '11px 18px', fontWeight: 700, fontSize: '13px', cursor: 'pointer', fontFamily: "'Syne',sans-serif" }}>
                    Anulează
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default function VehiclePage({ vehicle, onBack }) {
  const [activeTab, setActiveTab] = useState('expirari');
  const [expiryRefreshKey, setExpiryRefreshKey] = useState(0);

  const tabs = [
    {id:'expirari', label:'⏰ Expirări', desc:'și setări'},
    {id:'documente', label:'📄 Documente', desc:'și OCR'},
    {id:'acte', label:'📝 Acte Auto', desc:'generează'},
  ];

  return (
    <div>
      <button onClick={onBack} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555',marginBottom:'14px',fontSize:'12px'}}>
        ← Înapoi la mașini
      </button>

      {/* Hero vehicul */}
      <div style={{background:NAVY,borderRadius:'14px',padding:'20px 24px',marginBottom:'14px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr auto',gap:'16px',alignItems:'center'}}>
          <div>
            <div style={{fontFamily:'monospace',fontSize:'20px',fontWeight:700,color:GOLD,border:`2px solid ${GOLD}`,display:'inline-block',padding:'3px 12px',borderRadius:'7px',marginBottom:'8px',letterSpacing:'2px'}}>
              {vehicle.plate_number || vehicle.vin || '—'}
            </div>
            <div style={{color:'#fff',fontSize:'16px',fontWeight:700,marginBottom:'3px'}}>
              {[vehicle.brand, vehicle.model, vehicle.year].filter(Boolean).join(' ') || 'Vehicul'}
            </div>
            <div style={{color:'rgba(255,255,255,.5)',fontSize:'11px',fontFamily:'monospace'}}>
              {[vehicle.fuel_type, vehicle.emission_norm, vehicle.vin ? `VIN: ${vehicle.vin}` : null].filter(Boolean).join(' · ')}
            </div>
          </div>
          <div style={{textAlign:'right'}}>
            <div style={{background:'#FEF3DC',color:'#D4891A',fontSize:'10px',fontWeight:700,padding:'5px 12px',borderRadius:'14px',marginBottom:'6px'}}>
              ⚠ Verifică expirările
            </div>
            <div style={{color:'rgba(255,255,255,.3)',fontSize:'10px'}}>dosarmasina.ro</div>
          </div>
        </div>
      </div>

      {/* 3 Tab-uri principale */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'6px',marginBottom:'16px'}}>
        {tabs.map(t => (
          <button key={t.id} onClick={()=>setActiveTab(t.id)}
            style={{...s.btn,background:activeTab===t.id?GOLD:'#fff',color:activeTab===t.id?DARK:'#555',border:`0.5px solid ${activeTab===t.id?GOLD:'#D3D1C7'}`,padding:'12px 8px',display:'flex',flexDirection:'column',alignItems:'center',gap:'2px'}}>
            <span style={{fontSize:'13px',fontWeight:700}}>{t.label}</span>
            <span style={{fontSize:'10px',fontWeight:400,opacity:.7}}>{t.desc}</span>
          </button>
        ))}
      </div>

      {/* Conținut tab-uri */}
      {activeTab==='expirari' && <ExpiryTab vehicle={vehicle} refreshKey={expiryRefreshKey}/>}
      {activeTab==='documente' && <DocumentsUpload vehicleId={vehicle.id} onDataExtracted={() => setExpiryRefreshKey(k => k + 1)} onCustomExpirySaved={() => setExpiryRefreshKey(k => k + 1)}/>}
      {activeTab==='acte' && <ActeAuto vehicle={vehicle}/>}

      {/* Servicii disponibile */}
      <ServicesSection vehicle={vehicle}/>
    </div>
  );
}
